/* @flow */

import './SettingsModal.css';
import React from 'react';

import type { Profile } from '../../../helpers/profiles/typesAndConstants';
import type { ModalState } from '../../../redux/modal/reducers';

import Localizer from '../../../helpers/localization';
import { isProfilePrivate } from '../../../helpers/profiles/helpers';
import ProfilesManager from '../../../helpers/profiles/profilesManager';
import Avatar from '../../profiles/Avatar';
import ProfileTypeIndicator, { ProfileType } from '../../profiles/ProfileTypeIndicator';
import { AvatarSize } from '../../profiles/types';
import RowSettingToggle from '../../settings/RowSettingToggle';
import SharedSettings from '../../settings/SharedSettings';
import Modal from '../modal';

export type SettingsModalStateType = {
  isStartupProfile: boolean,
  currentProfile: Profile | null,
};

class SettingsModal extends React.PureComponent<ModalState, SettingsModalStateType> {
  constructor(props: ModalState) {
    super(props);

    const currentProfile = ProfilesManager.getCurrentProfile();

    this.state = { currentProfile, isStartupProfile: currentProfile !== null && ProfilesManager.startupProfile?.id === currentProfile.id };
  }

  handleIsStartupProfileOnChanged = (checked: boolean) => {
    const { currentProfile } = this.state;

    const localChecked = checked && currentProfile !== null;

    ProfilesManager.startupProfile = localChecked ? currentProfile : null;
    this.setState({ isStartupProfile: localChecked });
  };

  render(): React.Node {
    const { currentProfile, isStartupProfile } = this.state;

    return (
      <Modal className='settings'>
        <div className='profileSettings'>
          {currentProfile !== null ? (
            <div className='profileSettingsHeader'>
              <Avatar avatarId={currentProfile.avatarId} isDisabled name={currentProfile.name} profileId={currentProfile.id} size={AvatarSize.Medium} />
              <div className='avatarNameWrapper'>
                {Localizer.localize('profiles.settings.profile_header', { name: currentProfile.name })}
                {currentProfile.isKid || isProfilePrivate(currentProfile) ? <ProfileTypeIndicator profileType={currentProfile.isKid ? ProfileType.Kid : ProfileType.Private} /> : null}
              </div>
            </div>
          ) : null}

          <div className='settingsSection'>
            <div className='sectionTitle'>{Localizer.localize('settings.profiles.profile_title')}</div>
            <RowSettingToggle checked={isStartupProfile} className='settingsRow' onChange={this.handleIsStartupProfileOnChanged}>
              <div className='settingsLabel column'>
                <div>{Localizer.localize('profiles.settings.use_profile_at_startup')}</div>
                <div className='hint'>{Localizer.localize('profiles.settings.use_profile_at_startup_hint')}</div>
              </div>
            </RowSettingToggle>
          </div>
          <SharedSettings />
        </div>
      </Modal>
    );
  }
}

export default SettingsModal;
